const i18n = {
  'en-US': {
    'menu.profile.title': 'Profile',
    'profile.infoname': 'Name',
    'profile.infoemail': 'Email',
    'profile.infophone': 'Phone',
    'profile.infocorp_name': 'Company',
    'profile.infodept_name': 'Department',
    'profile.inforole_name': 'Role',
    'security.setting.title': 'Security',
    'security.setting.phone': 'Phone',
    'security.setting.email': 'Email',
    'security.setting.unbind': 'Unbind',
    'security.setting.bind': 'Bind',
    'security.setting.unbind.description': 'Are you sure to unbind?',
    'security.setting.none.phone': 'No phone number setup yet.',
    'security.setting.none.email': 'No email setup yet.',
    'security.setting.change_password': 'Change Password',
    'security.setting.old_password': 'Old Password',
    'security.setting.new_password': 'New Password',
    'security.setting.confirm_password': 'Confirm Password',
    'security.setting.verify_code': 'Verify Code',
    'security.setting.send_code': 'Send Code',
    'security.setting.resend': 'Resend Code',
    'security.setting.send_code.error': 'Failed to send code. Please try again.',
    'security.setting.submit': 'Submit',
    'security.setting.ok': 'OK',
    'security.setting.cancel': 'Cancel',
    'security.setting.enter': 'Please enter your ',
    'security.setting.phone_or_email': 'phone number or email',
    'security.setting.invalid_phone_or_email': 'Please enter a valid phone number or email.'
  },
  'zh-CN': {
    'menu.profile.title': '个人信息',
    'profile.infoname': '姓名',
    'profile.infoemail': '邮箱',
    'profile.infophone': '手机',
    'profile.infocorp_name': '公司',
    'profile.infodept_name': '部门',
    'profile.inforole_name': '角色',
    'security.setting.title': '安全设置',
    'security.setting.phone': '手机号',
    'security.setting.email': '邮箱',
    'security.setting.unbind': '解绑',
    'security.setting.bind': '绑定',
    'security.setting.unbind.description': '确认解绑？',
    'security.setting.none.phone': '未绑定手机号',
    'security.setting.none.email': '未绑定邮箱',
    'security.setting.change_password': '修改密码',
    'security.setting.old_password': '旧密码',
    'security.setting.new_password': '新密码',
    'security.setting.confirm_password': '确认密码',
    'security.setting.verify_code': '验证码',
    'security.setting.send_code': '发送验证码',
    'security.setting.resend': '重新发送验证码',
    'security.setting.send_code.error': '发送验证码失败，请稍后重试。',
    'security.setting.submit': '提交',
    'security.setting.ok': '确认',
    'security.setting.cancel': '取消',
    'security.setting.enter': '请输入您的',
    'security.setting.phone_or_email': '手机号或邮箱',
    'security.setting.invalid_phone_or_email': '请输入正确的手机号或邮箱'
  }
};
export default i18n;